// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--eMWRA";
export var content = "footer-module--content--lIB5M";
export var logoWrapper = "footer-module--logoWrapper--cydbm";